<template>
  <div class="class_progress_wrap">
    <div class="class_progress_title">
      <h2>班级进度详情</h2>
      <div class="class_progress_search">
        <el-select v-model="LearningState" clearable placeholder="学习状态" @change="getSearch" style="margin-right: 10px">
          <el-option
            v-for="item in LearningStateOpt"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-input 
          v-model="studentName"
          clearable
          placeholder="请输入学生姓名或学号"
          prefix-icon="el-icon-search"
          @keyup.native="getSearch"
          maxlength="20"></el-input>
        <el-button @click="getSearch">查询</el-button>
        <el-button @click="goBack">返回</el-button>
      </div>
    </div>
    <div class="class_progress_main" :style="'height:'+(height-150)+'px'" v-loading="loading">
      <div :style="'height:'+(tableData.length?(height-250):(height-210))+'px; overflow-y:auto; border: 1px solid #ebebeb; margin-top:16px'">
        <el-table
          :data="tableData"
          style="width: 100%;"
          :header-cell-style="{background:'#EDF4FE'}"
          class="collegeTable"
          :default-sort = "{prop: 'progress', order: 'descending'}"
          @sort-change="sortChange"
        >
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="jobNumber" label="学号">
            <template slot-scope="scope">
              <span>{{ scope.row.jobNumber? scope.row.jobNumber : '——'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="progress" label="学习状态">
            <template slot-scope="scope">
              <span v-if="scope.row.progress&&scope.row.progress>0">在学</span>
              <span v-else>未学</span>
            </template>
          </el-table-column>
          <el-table-column prop="progress" label="课程进度" sortable="custom" :sort-orders="['ascending', 'descending']">
            <template slot-scope="scope">
              <ul v-if="scope.row.progressList.length>0">
                <li v-for="(val,i) in scope.row.progressList" :key="i">
                  <span>{{val.resourceType | typeStatus}}类 {{val.progress}}%</span>
                </li>
              </ul>
              <span v-else>{{ scope.row.progress? scope.row.progress+'%' : '——'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="240">
            <template slot-scope="scope">
              <el-button round @click.native.prevent="openRow(scope.row)">{{scope.row.flag==0?'展开':'收起'}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination
        :currentpage="pageTotal.currentPage"
        :limit="pageTotal.pageSize"
        :total="pageTotal.total"
        layout="sizes, prev, pager, next, jumper"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
        :small="true"
        v-if="tableData.length"
      ></Pagination>
    </div>
  </div>
</template>
<script>
import * as api from '../../../../../../api/statisticsApi'
import Pagination from "../../../../../paginator/paginator";
export default {
  components: {Pagination},
  data() {
    return {
      loading: true,
      courseId: this.$route.query.id,
      classId: this.$route.query.classId,
      height: window.innerHeight,
      tableData: [],
      pageTotal: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      LearningState: '',//学习状态
      LearningStateOpt: [
        { value: '1', label: '在学' },
        { value: '0', label: '未学' }
      ],
      studentName: '', //学生姓名或学号,
      sort: 0//排序
    }
  },
  created() {
    this.getCourseProgressList()
  },
  filters: {
    typeStatus(type) {
      switch (type) {
        case 1:
          return "图片";
        case 2:
          return "文档";
        case 3:
          return "音频";
        case 4:
          return "视频";
        case 5:
          return "zip";
        case 6:
          return "实操";
        case 7:
          return "测验";
        case 8:
          return "笔记";
        case 9:
          return "发布讨论";
        case 10:
          return "回复讨论";
        case 11:
          return "评论讨论";
        default:
          return "实操";
          break;
      }
    }
  },
  methods: {
    goBack(){
      this.$router.go(-1)
    },
    getSearch(){
      this.getCourseProgressList()
    },
    getCourseProgressList(){
      let obj = {
        "classId": this.classId,
        "courseId": this.courseId,
        "pageNum": this.pageTotal.currentPage,
        "pageSize": this.pageTotal.pageSize,
        "name": this.studentName,
        "sort": this.sort,
        "status": this.LearningState?this.LearningState:''
      }
      api.getCourseProgressList(obj).then(rs=>{
        if(rs.code==0){
          this.tableData = []
          if (rs.data) {
            rs.data.list.forEach(v=>{
              let obj = {
                classId: v.classId,
                courseId: v.courseId,
                jobNumber: v.jobNumber,
                name: v.name,
                num: v.num,
                progress: v.progress,
                progressList: [],
                userId: v.userId,
                flag: 0
              }
              this.tableData.push(obj)
            })
            this.pageTotal = {
              pageSize: rs.data.pageSize,
              total: rs.data.total,
              currentPage: rs.data.pageNum
            }
          }
          this.loading = false
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    sortChange(row) {
      if(row.order == "ascending"){ this.sort = 0 }else if(row.order == "descending"){ this.sort = 1 }
      this.getCourseProgressList()
    },
    openRow(row){
      if(row.flag==0){
        api.getDetailProgress(this.courseId,this.classId,row.userId).then(rs=>{
          if(rs.code==0){
            if(rs.data.length>0){
              row.flag=1
              row.progressList = rs.data
            }else{
              this.$messageWarning('无进度')
            }
          }else{
            this.$messageError(rs.msg)
          }
        })
      }else{
        row.flag=0
        row.progressList = []
      }
    },
    handleCurrentChange(val) {//分页
      this.loading = true;
      this.pageTotal.currentPage = val;
      this.getCourseProgressList()
    },
    handleSizeChange(val){//分页
      this.loading = true;
      this.pageTotal.pageSize = val;
      this.pageTotal.currentPage = 1;
      this.getCourseProgressList()
    },
  },
}
</script>
<style lang="scss">
  .class_progress_wrap{
    margin: 0 16px;
    padding: 0 16px;
    background: #fff;
    box-sizing: border-box;
    .class_progress_title{
      height: 48px;
      border-bottom: 1px solid #5397F7;
      display: flex;
      align-items: center;
      position: relative;
      margin-top: 16px;
      h2{
        border-left: 2px solid rgba(83,151,247,1);
        color: #5397F7;
        font-size: 14px;
        padding-left: 4px;
        line-height: 10px;
      }
      .class_progress_search{
        position: absolute;
        right:0;
        display: flex;
        height: 30px;
        .el-input__inner{
          width: 240px;
          height: 30px;
        }
        .el-input__icon{
          line-height: 30px;
        }
        button{
          padding: 5px 18px;
          font-size: 12px;
          color: #5397F7;
          border-color: #5397F7;
          margin-left: 16px;
        }
        button:hover{
          background: #5397F7;
          color: #fff;
        }
      }
    }
    .class_progress_main{
      .collegeTable {
        border-radius: 4px;
        .el-button.is-round{
          padding: 5px 15px;
          border: 1px solid #5397F7;
          color: #5397F7;
          font-size: 12px;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/statistics/teacher/classProgress.vue